const login = 'LOGIN';
const logout = 'LOGOUT';

const initialState = { user: null, error: '' };

export const userActions = {

    login: (username, password) => async (dispatch, getState) => {
        const response = await fetch(`/api/users/authenticate`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ username, password })
        })
        if (!response.ok) {
            if (response.status === 401) {
                // auto logout if 401 response returned from api
                localStorage.removeItem('user');
                dispatch({ type: login, user: null, error: '아이디 또는 비밀번호가 잘못되었습니다.' });
            }
            //console.log(response);
            //const error = (response && response.message) || response.statusText;
            return;
        }
        const user = await response.json();
        localStorage.setItem('user', JSON.stringify(user));
        dispatch({ type: login, user });
    },

    logout: () => async (dispatch, getState) => {
        localStorage.removeItem('user');
        dispatch({ type: login });
    }

};

export const reducer = (state, action) => {
    state = state || initialState;

    switch (action.type) {
        case login:
            return { ...state, user: action.user, error: action.error };

        case logout:
            return { ...state, user: action.user };

        default:
            return state
    }
};



// WEBPACK FOOTER //
// ./src/store/private/user.js